import ruTrans from './ru-RU/translation.json';
import beTrans from './be-BY/translation.json';
import enTrans from './en-EN/translation.json';
import esTrans from './es-ES/translation.json';
import deTrans from './de-DE/translation.json';
import frTrans from './fr-FR/translation.json';
import plTrans from './pl-PL/translation.json';
import kkTrans from './kk-KZ/translation.json';

export { ruTrans, beTrans, enTrans, esTrans, deTrans, frTrans, plTrans, kkTrans };
